.emptyContainer {
  width: 100%;
  color: $white-10;

  .emptyCell {
    margin-inline: auto;
    text-align: center;
    padding-top: 10vh;
  }

  .inline {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: 1em;
  }
}
